import { checkInputSupport, checkMobileOperatingSystem, getMobileOperatingSystem, } from '../../../../../utilities/browser';
export const preferNativeDatepicker = () => {
    return (checkMobileOperatingSystem() &&
        getMobileOperatingSystem() !== 'android' &&
        checkInputSupport('date'));
};
